import { Col, Row } from "antd";
import * as moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { RecruiterActivity } from "redux/models/recruiterActivity";
import { MetricCard } from "features/dashboard/sections/weeklyActivity/metricCard/metricCard";
import { FunnelChart } from "features/dashboard/sections/weeklyActivity/funnelChart/funnelChart";
import { METRICS_CONFIG } from "features/dashboard/sections/weeklyActivity/metricsConfig";
import * as styles from "features/dashboard/sections/weeklyActivity/weeklyActivity.module.scss";
import { SectionError } from "features/dashboard/components/sectionError";
import { Section } from "features/dashboard/components/section";
import K from "utilities/constants";
import { MetricIconBadge } from "features/dashboard/components/metricIconBadge/metricIconBadge";

export const WeeklyActivity = ({ clientId, recruiterId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { metrics = {}, week } = data || {};

  const fetchActivity = useCallback(async () => {
    setError(null);
    setLoading(true);

    try {
      const { data: responseData } = await RecruiterActivity.weeklySummary(
        clientId,
        recruiterId,
        false,
      );
      setData(responseData);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [clientId, recruiterId]);

  const formatDate = (date) => {
    return moment(date).format(K.DateFormat.MonthDay);
  };

  const subtitle = week
    ? `Week of ${formatDate(week.start)} - ${formatDate(
        week.end,
      )} • Week to Date`
    : null;

  const renderMetricCard = (metric, showArrow = true) => (
    <MetricCard
      testId={metric.testId}
      icon={
        <MetricIconBadge
          icon={metric.icon}
          color={metric.color}
          bgColor={metric.bgColor}
        />
      }
      label={metric.label}
      description={metric.description}
      total={metrics[metric.key]?.total}
      goal={metrics[metric.key]?.goal}
      showArrow={showArrow}
      loading={loading}
      fetchCandidates={() =>
        RecruiterActivity.weeklyCandidates(
          clientId,
          recruiterId,
          metric.key,
          false,
        )
      }
    />
  );

  const renderContent = () => {
    if (error && !loading) {
      return <SectionError message={error} onRetry={fetchActivity} />;
    }

    return (
      <Row gutter={[16, 16]}>
        <Col flex="0 0 170px">
          <FunnelChart metrics={metrics} loading={loading} />
        </Col>

        <Col flex="1">
          <div className={styles.weeklyActivity__metricsGrid}>
            {METRICS_CONFIG.map((metric, i) => (
              <div key={metric.key}>
                {renderMetricCard(metric, i !== METRICS_CONFIG.length - 1)}
              </div>
            ))}
          </div>
        </Col>
      </Row>
    );
  };

  useEffect(() => {
    fetchActivity();
  }, [clientId, recruiterId, fetchActivity]);

  return (
    <Section title="Weekly Activity" subtitle={subtitle}>
      {renderContent()}
    </Section>
  );
};
